<template>
  <q-pull-to-refresh @refresh="refresh">
    <div v-if="shopId!==undefined" class="row full-width">
      <div class="col">
        <q-banner class="bg-blue text-white">
          <span>{{shopName}}</span>
        </q-banner>
      </div>
    </div>
    <div class="row">
      <div class="col-md-4 col-xs-12 q-pa-xs">
        <q-expansion-item
            :class="!$q.screen.lt.md?'shadow-1 overflow-hidden':'shadow-1 overflow-hidden'"
            label="درخواست های حواله ورودی"
            header-class="bg-indigo text-white"
            expand-icon-class="text-white"
            :default-opened="!$q.screen.lt.md">
          <q-table
              :data="lodash.orderBy(buyListGrouped, '[GoEvent_Date]', 'desc')"
              row-key="ID"
              wrap-cells
              flat
              :filter="filter"
              :pagination.sync="pagination">
            <template v-slot:header>
              <q-input :dense="$q.screen.lt.md" filled type="text"
                       label="جستجو بر اساس شماره درخواست حواله های ورودی" v-model="filter"/>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props" class="my-class">
                <q-td>
                  <q-card flat>
                    <q-card-section class="text-subtitle2 no-padding">
                      <div>
                        <q-btn @click="showBuyReceiveDetails(props.row)" icon="info"
                               padding="none" color="indigo"
                               text-color="white" round/>
                        <q-btn @click="loadReport(props.row)" icon="print" padding="none"
                               color="indigo"
                               v-if="props.row.GoEvent_Desc.indexOf('برگشت')===-1"
                               flat/>
                        {{ props.row.GoEvent_Desc }}
                        <q-badge align="top" rounded color="indigo" text-color="white"
                                 :label="props.row.GoEvent_Num"/>
                        <q-badge class="q-ml-xs" align="top" rounded color="red"
                                 text-color="white"
                                 :label="props.row.count"/>
                      </div>
                    </q-card-section>
                  </q-card>
                </q-td>
              </q-tr>
            </template>
          </q-table>

        </q-expansion-item>
      </div>
      <div class="col-md-4 col-xs-12 q-pa-xs">
        <q-expansion-item
            class="shadow-1 overflow-hidden"
            label="درخواست های انتقالی من"
            header-class="bg-indigo text-white"
            expand-icon-class="text-white"
            :default-opened="!$q.screen.lt.md"
        >
          <q-table
              :data="transferList"
              row-key="ID"
              wrap-cells
              flat
              :filter="filter"
              :pagination.sync="pagination">
            <template v-slot:header>
              <q-input :dense="$q.screen.lt.md" filled type="text"
                       label="جستجو بر اساس شماره درخواست انتقالی" v-model="filter"/>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props" class="my-class">
                <q-td>
                  <q-card flat>
                    <q-card-section class="text-subtitle2 no-padding">
                      <div>
                        <q-btn @click="showTransferDetails(props.row)" icon="info"
                               padding="none" color="indigo"
                               text-color="white" round/>
                        <q-btn icon="print" flat round @click="loadTransferReport(props.row)" color="indigo" />
                        {{ props.row.GoEvent_Desc }}
                        <q-badge align="top" rounded color="indigo" text-color="white"
                                 :label="Math.abs(props.row.GoEvent_Num)"/>
                        <q-badge class="q-ml-xs" align="top" rounded color="red"
                                 text-color="white"
                                 :label="props.row.GoEvent_Date"/>
                      </div>
                    </q-card-section>
                  </q-card>
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </q-expansion-item>
      </div>
      <div class="col-md-4 col-xs-12 q-pa-xs">
        <q-expansion-item
            class="shadow-1 overflow-hidden"
            label="حواله های فروش و برگشت از فروش"
            header-class="bg-indigo-10 text-white"
            expand-icon-class="text-white"
            :default-opened="!$q.screen.lt.md">
          <q-table
              :data="requestList.filter(item=>item.RequestType==='حواله')"
              row-key="CS_ID"
              wrap-cells
              flat
              :filter="filter"
              :pagination.sync="pagination">
            <template v-slot:header>
              <q-input :dense="$q.screen.lt.md" filled type="text"
                       label="جستجو بر اساس شماره حواله، سفارش و یا نام انبار" v-model="filter"/>
            </template>
            <template v-slot:body="props">
              <q-tr :props="props" class="my-class">
                <q-td>
                  <q-card flat>
                    <q-card-section class="no-padding">
                      <div class="row">
                        <div class="col-1 no-padding q-mr-sm">
                          <q-btn round color="indigo" icon="info"
                                 padding="none" size="md"
                                 v-if="props.row.RequestType === 'حواله'"
                                 @click="showOrderDetails(props.row)">
                            <q-tooltip>
                              مشاهده جزییات
                            </q-tooltip>
                          </q-btn>
                          <q-space/>
                          <q-btn round
                                 color="positive"
                                 v-if="!props.row.Rejected && $store.state.roles.some(v=>['admin','can_accept_hava'].includes(v))"
                                 icon="check" padding="none"
                                 class="q-mt-xs" size="md" @click="changeCredit(props.row)">
                            <q-tooltip>
                              تایید آماده سازی کالا
                            </q-tooltip>
                          </q-btn>
                          <q-space/>
                          <q-btn flat padding="none" size="md" round class="q-mt-xs"
                                 color="indigo"
                                 icon="print"
                                 @click="printHava(props.row)"/>
                        </div>
                        <div class="col-10">
                          <div class="row">
                            <div class="col">
                                                            <span v-if="props.row.Cs_Name"><b>{{
                                                                props.row.Cs_Name
                                                              }}</b></span>
                              <q-badge class="q-ml-xs" color="red" text-color="white"
                                       label="برگشتی"
                                       v-if="props.row.Sale_Kind===-1"/>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col">
                              <q-chip size="sm" v-if="props.row.RequestType === 'حواله'"
                                      square
                                      icon="email">
                                {{
                                  `${props.row.RequestType === 'حواله' ? `(${props.row.ResponseDateTime})` : ''}`
                                }}
                              </q-chip>
                              <q-chip size="sm" v-if="props.row.RequestType === 'حواله'"
                                      square
                                      icon="email">
                                {{
                                  `حواله ${props.row.RequestType === 'حواله' ? `(${props.row.Cs_UserID_To})` : ''}`
                                }}
                              </q-chip>
                              <q-chip size="sm" square icon="email">
                                {{
                                  `سفارش ${props.row.RequestType === 'حواله' ? `(${props.row.CS_UserID_From})` : ''}`
                                }}
                              </q-chip>
                            </div>
                          </div>

                          <div class="row">
                            <div class="col">
                              <q-chip size="sm" square color="purple" text-color="white"
                                      icon="person">{{ props.row.UserName }}
                              </q-chip>
                              <q-chip size="sm" v-if="props.row.CreditValue" square
                                      color="red"
                                      text-color="white"
                                      icon="attach_money">
                                {{ props.row.CreditValue | toCurrency }} ریال
                              </q-chip>
                              <q-chip size="sm" square color="deep-orange"
                                      text-color="white"
                                      icon="event">{{ props.row.RequestDateTime }}
                              </q-chip>
                              <q-space/>
                              <q-chip :label="props.row.State_Name" size="sm" square
                                      icon="location_city"/>
                              <q-chip :label="props.row.City_Name" size="sm" square
                                      icon="location_city"/>
                            </div>
                          </div>
                          <div class="row" v-if="props.row.Rejected">
                            <div class="col">
                              <q-chip size="sm" square color="red-14" text-color="white"
                                      icon="comment">{{ props.row.RejectReason }}
                              </q-chip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </q-card-section>
                  </q-card>
                </q-td>
              </q-tr>
            </template>
          </q-table>

        </q-expansion-item>
      </div>
    </div>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showCustomerFullInfo">
      <customer-info :selectedCustomer="this.selectedCustomer"/>
    </q-dialog>
    <q-dialog
        persistent
        ref="RequestActionDialog"
        v-model="showRequestActionDialog"
        :full-width="$q.screen.lt.md">
      <CreditRequestAction v-on:close-dialog="close" :request-info="selectedRequest"/>
    </q-dialog>

    <q-dialog
        maximized
        v-model="showOrderDetailsDialog">
      <hava-details :store_id="selectedStoreId" :hava_num="selectedHavaNum" :sale-num="selectedSaleNum"
                    :sale-kind="selectedSaleKind"/>
    </q-dialog>
    <q-dialog v-model="transferDetailsDialog" maximized>
      <TransferRequestDetails @close-dialog="closeTransferRequestDetails" @deleted-item="deletedItem"
                              :items="transferDetailsList"/>
    </q-dialog>

    <q-dialog maximized v-model="buyReceiveDetailsDialog">
      <GoodsReceiveConfirm @delete-item="deleteBuyListItem" :items="buyReceiveDetails"
                           :item-info="buyReceiveInfo"/>
    </q-dialog>
  </q-pull-to-refresh>
</template>

<script>
import {mapActions} from 'vuex'
import CustomerInfo from "@/components/customers/CustomerInfo";
import CreditRequestAction from "@/components/requests/CreditRequestAction";
import HavaDetails from "@/components/customers/HavaDetails";
import TransferRequestDetails from "@/components/requests/TransferRequestDetails";
import GoodsReceiveConfirm from "@/components/store/GoodsReceiveConfirm";

export default {
  name: "RequestsList",
  components: {GoodsReceiveConfirm, TransferRequestDetails, HavaDetails, CreditRequestAction, CustomerInfo},
  props: {
    shopId: {
      type: Number,
      default: () => undefined
    },
    shopName: {
      type: String,
      default: () => undefined
    }
  },
  data() {
    return {
      buyReceiveDetails: [],
      buyReceiveInfo: '',
      buyReceiveDetailsDialog: false,
      buyList: [],
      buyListGrouped: [],
      transferDetailsList: [],
      transferDetailsDialog: false,
      transferList: [],
      selectedCustomer: '',
      selectedSaleKind: 1,
      showRequestActionDialog: false,
      showCustomerFullInfo: false,
      showOrderDetailsDialog: false,
      selectedSaleNum: '',
      selectedRequest: '',
      selectedStoreId: '',
      selectedHavaNum: '',
      pagination: {
        rowsPerPage: 10
      },
      requestList: [],
      filter: '',
      filterFinal: ''
    }
  },
  methods: {
    ...mapActions({
      getRequestsList: 'Requests/getRequests',
      ChangeCredit: 'Customers/change_credit',
      AcceptHava: 'Orders/accept_hava',
      setExiState: 'Orders/setExiSaleState',
      getTransferDetails: 'Products/getGoodsTransferDetails'
    }),
    async loadTransferReport(rowInfo) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/انتقالی?rs:Format=PDF&RequestID=${rowInfo.GoEvent_Num}&rc:Parameters=False&rc:Zoom=Page Width`)
    },

    async loadReport(args) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/فرم حواله ورود به انبار?rs:Format=PDF&DocumentNo=${args.GoEvent_Num}&DocumentType=${311}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    deletedItem(args) {
      this.transferDetailsList = this.transferDetailsList.filter(item => item.Goods_IDD !== args)
    },
    closeTransferRequestDetails() {
      this.transferDetailsDialog = false
    },
    deleteBuyListItem(args) {
      this.buyReceiveDetails = this.buyReceiveDetails.filter(item => item.Goods_IDD !== args.Goods_IDD)
      this.buyList = this.buyList.filter(item => item.Goods_IDD !== args.Goods_IDD)
      this.buyListGrouped = this.lodash(this.buyList).groupBy('GoEvent_Num')
          .map(function (items, GoEvent_Num) {
            return {GoEvent_Num: GoEvent_Num, GoEvent_Desc: items[0].GoEvent_Desc, count: items.length};
          }).value();
    },
    showBuyReceiveDetails(row) {
      this.buyReceiveInfo = row
      this.buyReceiveDetails = this.buyList.filter(item => item.GoEvent_Num === parseInt(row.GoEvent_Num))
      this.buyReceiveDetailsDialog = true
    },
    showTransferDetails(row) {
      this.getTransferDetails(row.GoEvent_Num).then((res) => {
        this.transferDetailsList = res
        if (this.transferDetailsList.length > 0) {
          this.transferDetailsDialog = true
        }
      })
    },
    refresh(done) {
      setTimeout(() => {
        this.loadData()
        done()
      }, 1000)
    },
    loadData() {
      this.getRequestsList().then((res) => {
        this.requestList = this.shopId === undefined ? JSON.parse(res.requests) : JSON.parse(res.requests).filter(item => item.StoreID === this.shopId);
        this.transferList =this.shopId === undefined ? JSON.parse(res.transferList):JSON.parse(res.transferList).filter(item=> item.GoEvent_Desc.includes('فروشگاه'))
        this.buyList = this.shopId === undefined ? JSON.parse(res.BuyRequest) : JSON.parse(res.BuyRequest).filter(item=> item.GoEvent_StorID === this.shopId)
        this.buyListGrouped = this.lodash(this.buyList).groupBy('GoEvent_Num')
            .map(function (items, GoEvent_Num) {
              return {
                GoEvent_Date: items[0].GoEvent_Date,
                GoEvent_Num: GoEvent_Num,
                GoEvent_Desc: items[0].GoEvent_Desc,
                count: items.length
              };
            }).value();
      });
    },
    async printHava(rowInfo) {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات انبار/حواله خروج و برگشتی?rs:Format=PDF&SaleNum=${rowInfo.Cs_UserID_To}&SaleKind=${rowInfo.Sale_Kind}&StoreID=${rowInfo.StorID}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showDetails(row) {
      this.selectedCustomer = row;
      this.showCustomerFullInfo = true;
    },
    showCustomer(row) {
      this.selectedCustomer = row;
      this.showCustomerFullInfo = true;
    },
    changeCredit(row) {
      this.selectedRequest = row;
      if (row.RequestType === 'حواله') {
        this.$q.dialog({
          title: 'تاییدیه',
          message: 'از تایید حواله اطمینان دارید؟',
          cancel: true,
          persistent: true
        }).onOk(() => {
          this.AcceptHava({
            hava_num: row.Cs_UserID_To,
            store_id: row.StoreID,
            sale_kind: row.Sale_Kind,
            order_num: row.CS_UserID_From
          }).then((data) => {
            if (data.data.result !== -1) {
              this.$q.notify({
                message: `تاییدیه حواله صادر گردید`,
                color: 'positive',
                position: 'top',
                type: 'positive'
              });
              this.requestList.splice(this.requestList.indexOf(row), 1);
            } else {
              this.$q.notify({
                message: data.data.msg,
                color: 'negative',
                position: 'top',
                type: 'negative'
              });
            }
          });
        })
      } else {
        this.showRequestActionDialog = true;
      }
    },
    setHavaState(row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'از تایید حواله اطمینان دارید؟',
        cancel: true,
        persistent: true
      }).onOk(() => {
        this.setExiState(row.Cs_UserID_To).then((res) => {
          if (res.data.msg === 'unSuccess') {
            this.$q.notify({
              message: `راننده تعیین نشده است`,
              color: 'negative',
              position: 'top',
              type: 'negative'
            });
          } else {
            this.$q.notify({
              message: `حواله تایید گردید`,
              color: 'positive',
              position: 'top',
              type: 'positive'
            });
          }
        })
      })
    },
    showOrderDetails(row) {
      this.selectedSaleKind = row.Sale_Kind
      this.selectedSaleNum = row.CS_UserID_From;
      this.selectedStoreId = row.StoreID;
      this.selectedHavaNum = row.Cs_UserID_To;
      this.showOrderDetailsDialog = true;
    },
    showHavaDetails(row) {
      this.selectedSaleKind = row.Sale_Kind
      this.selectedSaleNum = row.CS_UserID_From;
      this.selectedStoreId = '1,2,3,4,5';
      this.selectedHavaNum = row.Cs_UserID_To;
      this.showOrderDetailsDialog = true;
    },

    close() {
      this.showRequestActionDialog = false;
      this.requestList.splice(this.requestList.indexOf(this.selectedRequest), 1);
    }
  },
  created() {
    this.loadData()
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
